import { render } from "./Progressbar.vue?vue&type=template&id=21057106&scoped=true"
import script from "./Progressbar.vue?vue&type=script&lang=js"
export * from "./Progressbar.vue?vue&type=script&lang=js"

import "./Progressbar.vue?vue&type=style&index=0&id=21057106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21057106"]])

export default __exports__